import { render, staticRenderFns } from "./uploadPDF.vue?vue&type=template&id=fb28ba5e&scoped=true&"
import script from "./uploadPDF.vue?vue&type=script&scoped=true&lang=js&"
export * from "./uploadPDF.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./uploadPDF.vue?vue&type=style&index=0&id=fb28ba5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb28ba5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb28ba5e')) {
      api.createRecord('fb28ba5e', component.options)
    } else {
      api.reload('fb28ba5e', component.options)
    }
    module.hot.accept("./uploadPDF.vue?vue&type=template&id=fb28ba5e&scoped=true&", function () {
      api.rerender('fb28ba5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadPDF.vue"
export default component.exports